import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom/client'

import App from '~/app'

// Initialize Sentry only on non-localhost environments
const environmentType: string = import.meta.env.VITE_ENV
const isLocalhost: boolean = window.location.hostname === 'localhost'
if (!isLocalhost) {
  const dsn: string = import.meta.env.VITE_SENTRY_DSN
  Sentry.init({
    dsn,
    tracesSampleRate: 1.0,
    sendDefaultPii: true,
    environment: environmentType,
  })
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
